import { render, staticRenderFns } from "./ReviewPlugin.vue?vue&type=template&id=472c60b8&scoped=true"
import script from "./ReviewPlugin.vue?vue&type=script&lang=js"
export * from "./ReviewPlugin.vue?vue&type=script&lang=js"
import style0 from "./ReviewPlugin.vue?vue&type=style&index=0&id=472c60b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c60b8",
  null
  
)

export default component.exports